module.exports = __webpack_public_path__ + "img/all_interfaces_nbg.9f5fdddb.png";